/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_A2Inputs */

const en_pc_alt_faq_a2 = /** @type {(inputs: Pc_Alt_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Adobe Acrobat and Foxit PDF Editor both edit the text and images already in a PDF. In PdfCraft that feature is still on the roadmap.`)
};

const zh_pc_alt_faq_a2 = /** @type {(inputs: Pc_Alt_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有。Adobe Acrobat 和 Foxit PDF Editor 都能编辑 PDF 中已有的文字和图片。PdfCraft 的这项功能仍在路线图上。`)
};

/**
* | output |
* | --- |
* | "Yes. Adobe Acrobat and Foxit PDF Editor both edit the text and images already in a PDF. In PdfCraft that feature is still on the roadmap." |
*
* @param {Pc_Alt_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_a2 = /** @type {((inputs?: Pc_Alt_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_a2(inputs)
	return zh_pc_alt_faq_a2(inputs)
});
export { pc_alt_faq_a2 as "pc.alt.faq.a2" }